import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "../../components/footer/footer.component";
import { NavbarComponent } from "../../components/navbar/navbar.component";
import { SidebarComponent } from "../../components/sidebar/sidebar.component";

@Component({
  selector: "app-admin-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.scss"],
  imports: [
    CommonModule,
    RouterModule,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
  ],
})
export class AdminLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
